module.exports = __webpack_public_path__ + "img/GAME_BALLOON.3f285932.png";